// import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'
// import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'
import ProjectMachineBarChart from '../Components/ProjectMachineBarChart'
import Select from 'react-select'

import useViewModel from './ViewModel'

const ProjectProgressionByMachineView: React.FC<WithChildren> = () => {
  const {
    sales,
    MACHINE_TYPE_FILTERS_OPTIONS,
    filterState,
    onChangeFilterState,
    apexChartOptions,
    apexChartSeries,
    categoryCount,
  } = useViewModel()

  return (
    <>
      <div className='row gy-5'>
        {/* <div className='col-12'>
          <PageBreadCrumb />
        </div> */}

        <div className='col-12'>
          <div className='card h-100'>
            <div className='card-header'>
              <div className='card-title fw-bolder'>ผลงานการตอกเสาเข็มแยกตามประเภทเครื่องจักร</div>
              <div className='card-toolbar w-lg-450px'>
                <div className='row g-5 w-100'>
                  <div className='col-12 col-md-6'>
                    <label className='mb-1 fw-bold text-muted fs-7'>ระบบการติดตั้ง</label>
                    <Select
                      value={
                        MACHINE_TYPE_FILTERS_OPTIONS.find(
                          option => option.value === filterState.machineType
                        ) ?? null
                      }
                      options={MACHINE_TYPE_FILTERS_OPTIONS}
                      onChange={(option: any) => {
                        onChangeFilterState('machineType', option?.value ?? 'ALL')
                      }}
                      styles={{
                        control: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          height: '34px !important',
                          minHeight: '34px !important',
                          fontSize: '0.875rem !important',
                        }),
                        placeholder: (baseStyles: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        singleValue: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        multiValue: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        option: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                      }}
                      isSearchable={false}
                      isClearable={false}
                      placeholder='เลือกมุมมองข้อมูล'
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </div>
                  <div className='col-12 col-md-6'>
                    <label className='mb-1 fw-bold text-muted fs-7'>ผู้ขาย</label>
                    <Select
                      value={sales.find(option => option.value === filterState.saleId) ?? null}
                      options={sales}
                      onChange={(option: any) => {
                        onChangeFilterState('saleId', option?.value ?? null)
                      }}
                      styles={{
                        control: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          height: '34px !important',
                          minHeight: '34px !important',
                          fontSize: '0.875rem !important',
                        }),
                        placeholder: (baseStyles: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        singleValue: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        multiValue: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                        option: (baseStyles: any, state: any) => ({
                          ...baseStyles,
                          fontSize: '0.875rem !important',
                        }),
                      }}
                      isSearchable={true}
                      isClearable={true}
                      placeholder='พิมพ์/เลือกผู้ขาย'
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='card-body'>
              {/* Chart */}
              <div className='row align-items-center justify-content-center h-100'>
                <div className='col-12 text-center'>
                  <ProjectMachineBarChart
                    options={apexChartOptions as any}
                    series={apexChartSeries as any}
                    categoryCount={categoryCount}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

// const ViewPageTitle: React.FC<WithChildren> = ({ children }) => {
//   return (
//     <>
//       <PageTitle
//         breadcrumbs={[
//           {
//             isActive: false,
//             isSeparator: false,
//             path: '#',
//             title: 'Dashboard',
//             icon: '/media/icons/duotune/general/gen005.svg',
//           },
//           {
//             isActive: true,
//             isSeparator: false,
//             path: '#',
//             title: 'กราฟแยกตามประเภทเครื่องจักร',
//           },
//         ]}>
//         ผลงานการตอกเสาเข็มแยกตามประเภทเครื่องจักร
//       </PageTitle>

//       {children}
//     </>
//   )
// }

export default ProjectProgressionByMachineView
